import { X } from "lucide-react";
import { Section, Kicker, Reveal } from "./primitives";

const PAINS = [
  <>Compiten contra empíricos por precio, cobrando <b className="text-slate-100">$20 o $30 dólares</b> por servicios que cualquiera puede hacer con alcohol y una brocha.</>,
  <>Sienten pánico cuando un equipo marca error, temiendo <b className="text-slate-100">descalibrar el bloque óptico</b> o rayar la celda de cuarzo frente a la mirada del bacteriólogo.</>,
  <>Cambian piezas a ciegas por descarte, esperando que un repuesto solucione una falla que <b className="text-slate-100">no supieron aislar por falta de método</b>.</>,
  <>Dependen ciegamente de <b className="text-slate-100">manuales de fábrica encriptados</b>, diseñados para vender tarjetas completas y mantener a los técnicos independientes fuera del negocio.</>,
];

export const Problema = () => (
  <Section id="problema">
    <Reveal>
      <Kicker num="01" label="La realidad del mercado" />
      <h2 className="max-w-3xl font-display text-2xl font-bold tracking-tight text-slate-50 sm:text-3xl lg:text-4xl">
        ¿Sigues atrapado en la guerra del centavo por hacer mantenimientos básicos?
      </h2>
      <p className="mt-5 text-base text-slate-400 md:text-lg">
        La mayoría de ingenieros y técnicos independientes viven bajo un estrés constante.
      </p>
    </Reveal>

    <div className="mt-12 space-y-5">
      {PAINS.map((p, i) => (
        <Reveal key={i} delay={i * 0.08}>
          <div className="flex items-start gap-4 rounded-2xl border border-white/5 bg-white/[0.02] p-5 transition-colors duration-300 hover:border-rose-400/25">
            <span className="mt-0.5 flex h-6 w-6 shrink-0 items-center justify-center rounded-full border border-rose-400/40 text-rose-400">
              <X className="h-3.5 w-3.5" />
            </span>
            <p className="text-sm leading-relaxed text-slate-400 sm:text-base">{p}</p>
          </div>
        </Reveal>
      ))}
    </div>

    <Reveal delay={0.2}>
      <p className="mt-12 border-l-2 border-cyan-400 pl-5 font-display text-lg font-medium text-slate-200 sm:text-xl">
        La universidad te enseñó ecuaciones teóricas, pero nadie te enseñó qué hacer
        frente a un analizador Mindray BA-88A descalibrado en una clínica real.
      </p>
    </Reveal>
  </Section>
);
